import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
    return (
        <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
            {/* Background Image with Overlay */}
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 z-0 bg-dark-900">
                <div className="absolute inset-0 bg-gradient-to-br from-dark-900 via-dark-800 to-black opacity-90" />
                <div className="absolute inset-0 opacity-10"
                    style={{
                        backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
                        backgroundSize: '40px 40px'
                    }}
                />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold-500/10 via-transparent to-transparent" />
            </div>

            <div className="relative z-20 text-center px-4 max-w-4xl mx-auto">
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-gold-400 uppercase tracking-[0.2em] mb-4 text-sm md:text-base font-semibold"
                >
                    Welcome to Excellence
                </motion.h2>

                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="text-5xl md:text-7xl font-serif text-white mb-6 leading-tight"
                >
                    Refining Luxury Spaces <br /> across the UAE
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="text-gray-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto font-light"
                >
                    Specializing in marble polishing, tile installation, intricate ceiling works, and bespoke joinery.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                >
                    <a
                        href="#contact"
                        className="inline-block border-2 border-gold-400 text-gold-400 px-8 py-3 uppercase tracking-widest hover:bg-gold-400 hover:text-white transition-all duration-300"
                    >
                        Request a Consultation
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
